export const INITIAL_PAGE = 1;
export const INITIAL_TOTAL_PAGES = 1;
export const DEFAULT_WIDTH = 1000;
export const DEFAULT_HEIGHT = 1000;
export const ZOOM_STEP = 0.2;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/constants.ts